import { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react';
import cn from 'classnames';
import styles from './keto-container-fluid.module.css';

export interface KetoContainerFluidProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  children: ReactNode;
}

export default function KetoContainerFluid({
  children,
  className,
  ...props
}: KetoContainerFluidProps) {
  return (
    <div {...props} className={cn(className, styles['container-fluid'])}>
      {children}
    </div>
  );
}
